import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { getV2Audit } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable"; // TODO:
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { AsyncPaginate } from "react-select-async-paginate";
import { loadAccounts, loadUsers } from "../../utils/optionLoaderUtils";
import { customStyles } from "../../utils/styleUtils";

const AccountAudit = () => {
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null)
    const { ref, inView } = useInView();
    const queryKey = ['audit', selectedAccount, selectedUser, decouncedSearchValue];

    const {
        data,
        fetchNextPage,
        isLoading,
        isFetching,
        isSuccess,
        hasNextPage,
        isFetchingNextPage,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = {
                entityType: 'ACCOUNT',
                lastEvaluatedKey: pageParam,
            };
            if (selectedAccount) {
                params.entityId = selectedAccount.additional.accountHccId;
            } else if (selectedUser) {
                params.email = selectedUser.value;
            }
            return getV2Audit(params);
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    if (item.requestBody) {
                        try {
                            item.requestBodyParsed = JSON.parse(item.requestBody);
                        } catch (err) {
                            // noop
                        }
                    }
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
        },
        getNextPageParam: (lastPage, _allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null;
        },
        staleTime: 0,
        enabled: !!(selectedAccount || selectedUser)
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['pk', 'sk', 'action', 'entityId'];

    const results = data?.pages.flat()
    return (
        <div className="container">
            <p className="title">Account Audit</p>
            <p className="sub-title">Change history</p>
            <p className="sub-title">Search by user or account hcc ID </p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                    {!selectedUser && <AsyncPaginate
                        placeholder={"Select an account"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedAccount}
                        loadOptions={loadAccounts}
                        onChange={(val) => { setSelectedAccount(val); setSelectedUser(null) }}
                        styles={customStyles}
                        isClearable
                    />}

                    {!selectedUser && !selectedAccount && <p>OR</p>}
                    {!selectedAccount && <AsyncPaginate
                        placeholder={"Select a User"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedUser}
                        loadOptions={loadUsers}
                        onChange={(val) => { setSelectedUser(val); setSelectedAccount(null) }}
                        styles={customStyles}
                        isClearable
                    />}
                    {(selectedAccount || selectedUser) && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"sk-prefix"}
                        placeholder="sk prefix ..."
                        autoComplete="off"
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSelectedUser(null)
                        setSelectedAccount(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>
            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : isSuccess ? (
                <>
                    <SharedTable
                        type={"account-audit"}
                        columns={columns}
                        items={results}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        ref={ref}
                    />
                </>
            ) : <></>}
        </div>
    )
}

export default AccountAudit
